<template>
  <div>
    <logged-in-header />
    <users />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import users from "../components/users/UsersPanel";

export default {
  components: {
    loggedInHeader,
    users
  }
};
</script>
